var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-item button", class: [_vm.item.data.htmloptions] },
    [
      _c(
        "button",
        {
          class: [
            "btn btn-primary",
            { "btn--loading": this.loader, "btn--success": this.success },
          ],
          attrs: { type: "submit" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            },
          },
        },
        [
          !_vm.loader
            ? _c("span", [_vm._v(_vm._s(_vm.genLabel))])
            : _c("span", { staticClass: "spinner-border" }),
          _vm._v(" "),
          _vm.success
            ? _c("i", { staticClass: "icon-form-checkmark" })
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }